import { Product } from "types";
import { validateParams } from "../hookHelpers";
import { Options, useCollection } from "../useCollection";

export const useDeletedExperiences = (params: any = null, options: Options<Product> = {}) => {
    params = validateParams(params);

    const fetchParams = { ...params, deleted: true };

    const response = useCollection<Product>(["experiences"], fetchParams, options);

    return { ...response, deletedExperiences: response.data, isLoadingDeletedExperiences: response.isLoading };
};
